import { CountUp } from 'countup.js';

const counts = Array.from(document.getElementsByClassName('count-up'));
if (counts.length) {
  const defaultOptions = {
    separator: '',
    enableScrollSpy: true,
    scrollSpyRunOnce: true,
  };

  const initCounters = () => {
    let idNumber = 1;

    counts.forEach((count) => {
      const id = `count-up-${idNumber}`,
          value = parseFloat(count.innerHTML);

      const minWidth = count.getBoundingClientRect().width;
      count.style.minWidth = `${minWidth}px`;
      count.style.opacity = '';

      let optionsFromDataAttr = { ...count.dataset };

      for (const key in optionsFromDataAttr) {
        if (optionsFromDataAttr[key] === '') {
          optionsFromDataAttr[key] = true;
        }
      }

      const decimalPlaces = (count.innerHTML.split('.')[1]?.length) || 0;

      count.id = id;
      new CountUp(
          id,
          value,
          Object.assign({}, defaultOptions, optionsFromDataAttr, { decimalPlaces })
      );
      idNumber++;
    });
  };

  // Скрываем до загрузки шрифтов
  counts.forEach((count) => {
    count.style.opacity = '0';
  });

  if (document.fonts?.ready) {
    document.fonts.ready.then(initCounters);
  } else {
    // Fallback для старых браузеров
    document.addEventListener('DOMContentLoaded', initCounters);
  }
}